<template>
  <div v-if="fileName" class="file-preview">
    <span>{{ fileName }}</span>
    <div class="file-preview__overlay">
      <span>
        <i class="el-icon-delete" @click="removeFile"></i>
      </span>
    </div>
  </div>
  <div v-else-if="imageUrl" class="file-preview">
    <img class="file__img"
         :src="imageUrl"
         alt="logo"
    />
    <div class="file-preview__overlay">
      <span>
        <i class="el-icon-delete" @click="removeFile"></i>
      </span>
    </div>
  </div>
  <div v-else class="file-uploader">
    <label class="">
      <span class="file-uploader__icon">
        <i slot="default" class="el-icon-plus"></i>
      </span>
      <input
        type="file"
        class="file-uploader__input"
        :name="name"
        :accept="fileType"
        @change="handleFilePreview"
      >
    </label>
    <span class="text-xs file__placeholder">{{ placeholder }}</span>
  </div>
</template>
<script>
export default {
  name: 'FileUpload',
  props: {
    fileType: { type: String, required: true },
    viewType: { type: String, default: 'text' },
    name: { type: String, required: true },
    placeholder: { type: String, default: 'Select File' },
  },
  data() {
    return {
      file: {},
      fileName: '',
      imageUrl: '',
    };
  },
  methods: {
    handleFilePreview(event) {
      const [file] = event.target.files;
      const { viewType } = this;

      if (viewType === 'text') {
        this.fileName = file.name;
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      }
      this.file = file;
      this.$emit('fileInput', {
        name: this.name,
        file: this.file,
      });
    },
    removeFile() {
      this.fileName = '';
      this.imageUrl = '';
      this.file = {};
      this.$emit('fileInput', {
        name: this.name,
        file: null,
      });
    },
  },
};
</script>

<style lang="scss">
  @import '../../../assets/css/file_upload';
</style>
